module.exports = __webpack_public_path__ + "img/empty-device-list.6d3b7a1d.svg";